import { ProductInstanceModel } from '@dc-console-api';
import { RoleModel } from '@requesters/models/role.model';

export enum ModuleInstanceType {
	DcMarketplace = 'Dc Marketplace',
	Console = 'Dc console',
	Core = 'Dc core',
	DcMaestro = 'Dc Maestro',
	DcCode = 'Dc Code',
	Unspecified = 'unspecified',
}

export const ModuleInstanceTypeOrder: { [k: string]: number } = {
	[ModuleInstanceType.Console]: 0,
	[ModuleInstanceType.Core]: 1,
	[ModuleInstanceType.DcMarketplace]: 2,
	[ModuleInstanceType.DcMaestro]: 3,
	[ModuleInstanceType.DcCode]: 4,
	[ModuleInstanceType.Unspecified]: 42,
};

export const AvailableModulesMapping = {
	[ProductInstanceModel.TypeEnum.DcConsole]: ModuleInstanceType.Console,
	[ProductInstanceModel.TypeEnum.DcMarketplace]:
		ModuleInstanceType.DcMarketplace,
	[ProductInstanceModel.TypeEnum.DcCore]: ModuleInstanceType.Core,
	[ProductInstanceModel.TypeEnum.DcMaestro]: ModuleInstanceType.DcMaestro,
	[ProductInstanceModel.TypeEnum.Pydc]: ModuleInstanceType.DcCode, // TO FIX
	[ProductInstanceModel.TypeEnum.ExternalApp]: ModuleInstanceType.Unspecified,
};

export enum ModuleRole {
	NoSpecificRole = 'Noop',
	Member = 'member',
	ProjectCreator = 'creator',
	Consumer = 'consumer',

	OrganizationAdmin = 'organization-admin',
	SuperAdmin = 'super-admin',
	ModuleAdmin = 'module-admin',

	IndirectMember = 'indirect-member',
	IndirectAdmin = 'indirect-admin',
}

export type MembershipType = {
	type: ModuleRole;
	hasRole: boolean;
	isInherited: boolean;
	inheritedFromGroups?: Set<string>;
};

export type MembershipSources = Omit<MembershipType, 'inheritedFromGroups'>;

export const ModuleRoleOrder: { [k: string]: number } = {
	[ModuleRole.Consumer]: 0,
	[ModuleRole.Member]: 1,
	[ModuleRole.ProjectCreator]: 2,
	[ModuleRole.ModuleAdmin]: 3,
	[ModuleRole.OrganizationAdmin]: 4,
	[ModuleRole.SuperAdmin]: 5,
};

export const RolesMapping: { [k: string]: ModuleRole } = {
	[RoleModel.DCV_MEMBER]: ModuleRole.Member,
	[RoleModel.DCV_ADMIN]: ModuleRole.ModuleAdmin,

	[RoleModel.DCC_MEMBER]: ModuleRole.Member,
	[RoleModel.DCC_ADMIN]: ModuleRole.ModuleAdmin,
	[RoleModel.DCC_ORGANIZATION_ADMIN]: ModuleRole.OrganizationAdmin,

	[RoleModel.DC_MEMBER]: ModuleRole.Member,
	[RoleModel.DC_PROJECT]: ModuleRole.ProjectCreator,
	[RoleModel.DC_ADMIN]: ModuleRole.ModuleAdmin,
	[RoleModel.DC_CONSO]: ModuleRole.Consumer,
};

export const ModuleToRolesMapping: {
	[k: string]: Array<ModuleRole>;
} = {
	[ProductInstanceModel.TypeEnum.DcConsole]: [
		ModuleRole.Member,
		ModuleRole.ModuleAdmin,
		ModuleRole.OrganizationAdmin,
	],
	[ProductInstanceModel.TypeEnum.DcMarketplace]: [
		ModuleRole.Member,
		ModuleRole.ModuleAdmin,
	],
	[ProductInstanceModel.TypeEnum.DcCore]: [
		ModuleRole.Consumer,
		ModuleRole.Member,
		ModuleRole.ModuleAdmin,
		ModuleRole.ProjectCreator,
	],
};
